import { Product } from "../types/product.type";

export function format(first?: string, middle?: string, last?: string): string {
  return (first || '') + (middle ? ` ${middle}` : '') + (last ? ` ${last}` : '');
}

export function getDiscountText(product: Product): string {
  const { discount, discountType } = product;
  let discountText: string;

  if (discountType === "percentage") {
      discountText = `خصم ${discount}%`;
  } else {
      discountText = `خصم ${money(discount)}`;
  }

  return discountText;
}

export function money(amount: number | string) {
  const num = typeof amount === 'string' ? parseFloat(amount) : amount;

  if (!isNaN(num)) {
    const currencyData = window.__qumra__.data.app.currency;
    return `${num.toFixed(2)} ${currencyData.currencySymbol}`;
  }

  return 'يجب أن يكون رقمًا صالحًا';
}

